import DynamicModuleRegistrationUtil from '../utils/dynamicModuleRegistration'
import { store } from '../store'
import ImportProductsEnum from '../enums/modules/routes/importProducts'
import ProductsEnum from '../enums/modules/routes/products'

// Vuex Modules to load
const ImportProductsStoreModule = () => import(/* webpackChunkName: "ImportProducts" */ '../store/modules/importProducts')

// Components to load
const ImportProducts = () => import(/* webpackChunkName: "ImportProducts" */ '@/components/products/import/ImportProducts')
const ImportProductsConfirmation = () => import(/* webpackChunkName: "ImportProducts" */ '@/components/products/import/ImportProductsConfirmation')
const EmailProductsTemplate = () => import(/* webpackChunkName: "ImportProducts" */ '@/components/products/import/EmailProductsTemplate')
const ProductTemplateOptions = () => import(/* webpackChunkName: "ImportProducts" */ '@/components/products/import/ProductTemplateOptions')
const UploadProducts = () => import(/* webpackChunkName: "ImportProducts" */ '@/components/products/import/UploadProducts')

// ******************************************************
// *************** Route Guard Functions ****************
// ******************************************************

const dynamicModuleRegistrationOrdersArgs = () => {
  return {
    modulesNamespace: store._modulesNamespaceMap,
    moduleName: 'importProducts',
    module: ImportProductsStoreModule,
    store,
    modulePath: 'importProducts',
    registerOptions: { preserveState: false }
  }
}

const iHaveAccess = () => {
  return store.state.settings.globalSettings.enableBulkProductImport
}

// ******************************************************
// ****************** Route Definitions *****************
// ******************************************************

export default [
  {
    path: '/Products/Import',
    component: ImportProducts,
    name: ImportProductsEnum.ImportProducts,
    beforeEnter (_to, _from, next) {
      DynamicModuleRegistrationUtil(dynamicModuleRegistrationOrdersArgs()).then(
        () => next()
      )
      if (!iHaveAccess()) next({ name: ProductsEnum.Products })
    },
    children: [
      {
        path: 'Template',
        component: ProductTemplateOptions,
        name: ImportProductsEnum.TemplateOptions
      },
      {
        path: 'Email',
        component: EmailProductsTemplate,
        name: ImportProductsEnum.EmailTemplate
      },
      {
        path: 'Upload',
        component: UploadProducts,
        name: ImportProductsEnum.UploadProducts
      },
      {
        path: 'Confirmation',
        component: ImportProductsConfirmation,
        name: ImportProductsEnum.Confirmation
      }
    ]
  }
]
